import angular from 'angular';
import { progressBackgroundDirective } from './progressBackgroundDirective';

angular
	.module('sh.progressBackground', [])
	.directive('shProgressBackground', progressBackgroundDirective)
	.directive('shProgressBackgroundCountdown', progressBackgroundDirective);
